import { render, staticRenderFns } from "./traffic-light-quality-chart.vue?vue&type=template&id=b7ff4b5c"
import script from "./traffic-light-quality-chart.vue?vue&type=script&lang=js"
export * from "./traffic-light-quality-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports